import qs from 'qs';

// ?v=1 / ?v=2 in the link wins, so both designs can be compared on any survey;
// otherwise the survey's own ui_version (set in admin) decides.
export const forcedVersion = () => {
  const { v } = qs.parse(window.location.search, { ignoreQueryPrefix: true });
  return v === '1' || v === '2' ? Number(v) : null;
};

export const isV2 = (survey) => (forcedVersion() || survey?.ui_version || 1) === 2;
